export default "__VITE_ASSET__6f616a55__"